export { default } from './collapse.component';
